import { MessageResponse } from "./messageResponse";

export class SubscribeToGuaranteedIncomeResponse extends MessageResponse {
  purchasePrice: number;
}
